// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a00c1d3f","457":"2f119b4b","551":"7703be69","760":"bbcb1269","940":"5039e1a4"}[chunkId] + ".chunk.js";
};